export const E_LIBRARY = '/e_library/' as const
export const E_LIBRARY_ALL = `${E_LIBRARY}all` as const
export const E_LIBRARY_TYPES = `${E_LIBRARY}types` as const
